export function parseBips(value: string | number | undefined | null) {
  if (value === undefined || value === null || !Number.isSafeInteger(value)) {
    return
  }
  return Number((Number(value) / 100).toFixed(2))
}
